import { styled, media } from 'src/styles/styled-components'

export default styled.h2`
  font-size: 2.8rem;
  font-weight: ${ p => p.theme.fontWeight.primary.Light };
  line-height: 1.18;
  margin-bottom: 20px;
  text-align: center;

  ${ media.tablet`
    font-size: 3.8rem;
    margin-bottom: 10px;
  ` }

  ${ media.desktop`
    font-size: 4.5rem;
    margin-bottom: 30px;
  ` }
`
